"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const typesConstants_1 = require("../../../constants/typesConstants");
const useAppDispatch_1 = __importDefault(require("../../../hooks/useAppDispatch"));
const communicationBoxUtils_1 = require("../communicationBoxUtils");
const utils_1 = require("../../../utils/utils");
const styles_1 = __importDefault(require("../../../styles/styles"));
const communicationBoxDropdown_1 = __importDefault(require("../communicationBoxDropdown/communicationBoxDropdown"));
const themes_1 = __importDefault(require("../../../styles/themes"));
const FieldErrorMessageComponent_1 = __importDefault(require("../../FieldErrorMessageComponent/FieldErrorMessageComponent"));
const button_1 = __importDefault(require("../../button/button"));
const eventConstants_1 = require("../../../constants/eventConstants");
const voipCall_1 = __importDefault(require("./voipCall"));
const authSlice_1 = require("../../../features/auth/authSlice");
const select_1 = __importDefault(require("../../select/select"));
const communicationSlice_1 = require("../communicationSlice");
const useAppSelector_1 = __importDefault(require("../../../hooks/useAppSelector"));
const VoipCallOutbound = ({ officer }) => {
    const { callerIDs, selectedcallerID } = useAppSelector_1.default((state) => ({
        callerIDs: state.communication.callerIDs,
        selectedcallerID: state.communication.selectedCallerID,
    }));
    const dispatch = useAppDispatch_1.default();
    const [phoneNumberError, setPhoneNumberError] = react_1.useState('Enter phone number');
    const [phoneNumber, setPhoneNumber] = react_1.useState('+234');
    const [displayVoipCall, setDisplayVoipCall] = react_1.useState(false);
    const voipProviders = officer.voip_providers;
    const voipProvider = officer.current_voip_provider;
    const isButtonDisabled = !!phoneNumberError;
    const displaySelectNumber = officer.officer_type === typesConstants_1.OFFICER_TYPES_OPERATIONS;
    const selectedCallerIDNumber = selectedcallerID && selectedcallerID.number;
    const updateVoipCallProvider = (provider) => {
        dispatch(authSlice_1.updateVoipProvider({ backend_value: provider }));
    };
    react_1.useEffect(() => {
        if (!voipProvider)
            return;
        dispatch(communicationSlice_1.getCallerIDS({ provider: voipProvider.backend_value, is_active: true }));
    }, [voipProvider]);
    const callerIDChoices = react_1.useMemo(() => communicationBoxUtils_1.buildCallerIDOptions(callerIDs), [callerIDs]);
    const updateCustomPhoneNumber = (value) => {
        const formattedPhoneNumber = communicationBoxUtils_1.formatPhoneNumber(value);
        setPhoneNumberError(utils_1.validatePhoneNumber(formattedPhoneNumber.substring(4)));
        setPhoneNumber(formattedPhoneNumber);
    };
    const contacts = [
        {
            available_sms: [],
            first_name: 'Custom Phone',
            last_name: 'Number',
            phone_number: phoneNumber,
        },
    ];
    const onSearch = (value) => {
        if (!voipProvider)
            return;
        dispatch(communicationSlice_1.getCallerIDS({ provider: voipProvider.backend_value, is_active: true, number: value }));
    };
    const handleCallerIDChange = (selectedNumber) => {
        const selectedCallerID = callerIDs.find((callerID) => callerID.number === selectedNumber);
        dispatch(communicationSlice_1.updateCallerID(selectedCallerID));
    };
    const hasError = !!phoneNumberError;
    return (react_1.default.createElement(react_native_1.View, null,
        react_1.default.createElement(react_native_paper_1.Card, { style: [styles_1.default.whiteBackground] },
            react_1.default.createElement(react_native_paper_1.Card.Title, { title: "Outbound Calls", subtitle: voipProvider && voipProvider.display_value, titleStyle: styles_1.default.textColorBlack, subtitleStyle: styles_1.default.textColorGray, right: () => (react_1.default.createElement(communicationBoxDropdown_1.default, { voipCallProviders: voipProviders, action: updateVoipCallProvider })) }),
            react_1.default.createElement(react_native_paper_1.Card.Content, null,
                react_1.default.createElement(react_native_1.View, { style: [
                        styles_1.default.flexDirectionRow,
                        !hasError && displaySelectNumber && styles_1.default.paddingTwenty,
                    ] },
                    displaySelectNumber && (react_1.default.createElement(select_1.default, { value: selectedCallerIDNumber || undefined, setValue: handleCallerIDChange, choices: callerIDChoices, style: [styles_1.default.select, styles_1.default.flexOne], searchable: true, onSearch: onSearch })),
                    react_1.default.createElement(react_native_1.View, { style: [
                            styles_1.default.flexThree,
                            hasError ? styles_1.default.marginTopForty : styles_1.default.marginTopTen,
                        ] },
                        react_1.default.createElement(react_native_paper_1.TextInput, { label: "Phone number", placeholder: "Enter phone number", left: true, style: [
                                styles_1.default.customPhoneInput,
                                styles_1.default.textInput,
                                displaySelectNumber && { height: 60, marginLeft: 0 },
                            ], onChangeText: updateCustomPhoneNumber, value: phoneNumber, theme: themes_1.default.textInput }),
                        hasError && (react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginLeftThirty, styles_1.default.marginBottomTen] },
                            react_1.default.createElement(FieldErrorMessageComponent_1.default, { text: phoneNumberError }))))),
                react_1.default.createElement(button_1.default, { fill: true, text: "Call", icon: free_solid_svg_icons_1.faPhone, onPress: () => setDisplayVoipCall(true), eventName: eventConstants_1.VOIP_CALL_BUTTON, disabled: isButtonDisabled }),
                displayVoipCall && (react_1.default.createElement(voipCall_1.default, { selectedContact: contacts[0], setBaseContent: () => setDisplayVoipCall(false), userPhoneNumber: phoneNumber, scheduleId: "", voipCallProvider: voipProvider }))))));
};
exports.default = VoipCallOutbound;
